// Producer types (producers.producer_type enum): display metadata for the
// panel title glyph. German term + description ride the tooltip; the enum
// values and this legend mirror the column comment in sql/01. Icons are
// illustrated PNGs in the flavor-icon style (public/producer-types/,
// 512px sources in design/producer-types-512/).

export const PRODUCER_TYPES = {
  estate: {
    label: 'Wine Estate', german: 'Weingut', icon: '/producer-types/estate.png',
    description: 'individual producer growing and vinifying its own grapes',
  },
  cooperative: {
    label: "Winegrowers' Cooperative", german: 'Winzergenossenschaft', icon: '/producer-types/cooperative.png',
    description: 'member-owned cellar vinifying grapes from many growers',
  },
  merchant: {
    label: 'Merchant Winery', german: 'Weinkellerei', icon: '/producer-types/merchant.png',
    description: 'commercial firm buying grapes, must, or wine to blend and bottle',
  },
  estate_merchant: {
    label: 'Estate & Merchant Winery', german: 'Weingut-Weinkellerei', icon: '/producer-types/estate_merchant.png',
    description: 'owns vineyards but also buys in fruit or wine',
  },
  producers_association: {
    label: "Producers' Association", german: 'Erzeugergemeinschaft', icon: '/producer-types/producers_association.png',
    description: 'growers marketing jointly without a shared cellar',
  },
  sekt_house: {
    label: 'Sparkling Wine House', german: 'Sekthaus', icon: '/producer-types/sekt_house.png',
    description: 'specialist producer of Sekt, often from purchased base wines',
  },
};

// Favorite producers (producers.is_favorite): gold star in the panel title
// and sidebar lists. Payloads that predate the column — notably the baked
// static key-items JSON between deploys — fall back to the known names.
const FAVORITE_FALLBACK = ['2Naturkinder', 'Emrich-Schönleber'];
export function isFavoriteProducer(p) {
  if (typeof p?.is_favorite === 'boolean') return p.is_favorite;
  return FAVORITE_FALLBACK.some((n) => p?.name?.includes(n));
}
